import { CustomNextImage } from '@crehana/next';

interface SuccessGifProps {
  isDark?: boolean;
  isEmailGIF?: boolean;
  size?: number;
}

const darkCheckGIF =
  'https://crehana-vercel-images-prd.imgix.net/public/b2b-admin-mf/602df156-6e09-4e60-aee5-356905f2d5aa-check-dark.gif';
const lightCheckGIF =
  'https://crehana-vercel-images-prd.imgix.net/public/b2b-admin-mf/9f795108-b273-4428-82eb-56ee6b5edfaa-check-light.gif';

const darkEmailGIF =
  'https://crehana-vercel-images-prd.imgix.net/public/b2b-admin-mf/feeb95a5-97d2-4269-a94e-3bf34c58732e-email-dark.gif';
const lightEmailGIF =
  'https://crehana-vercel-images-prd.imgix.net/public/b2b-admin-mf/4bc1c1c4-a312-4f04-8d95-d25710b541f4-email-light.gif';

const SuccessGif: React.FC<SuccessGifProps> = ({
  isDark,
  isEmailGIF,
  size = 150,
}) => {
  const checkGIF = isDark ? darkCheckGIF : lightCheckGIF;
  const emailGIF = isDark ? darkEmailGIF : lightEmailGIF;

  return (
    <CustomNextImage
      alt="success-gif"
      height={size}
      src={isEmailGIF ? emailGIF : checkGIF}
      width={size}
    />
  );
};

export default SuccessGif;
